export const TEST_ORG_NAME_TAG = "[TEST]";

/** SQL LIKE pattern for GraphQL `_nilike` (excludes org names containing [TEST]). */
export const EXCLUDE_TEST_ORG_NAME_NILIKE = "%\\[TEST\\]%";

export function isTestOrganizationName(name?: string | null): boolean {
  return Boolean(name?.includes(TEST_ORG_NAME_TAG));
}

export function excludeTestOrganizations<T extends { name?: string | null }>(
  organizations: T[],
): T[] {
  return organizations.filter(
    (organization) => !isTestOrganizationName(organization.name),
  );
}

export function getNonTestOrganizationIds(
  organizations: Array<{ org_id?: string | null; name?: string | null }>,
): string[] {
  return excludeTestOrganizations(organizations)
    .map((organization) => organization.org_id)
    .filter((orgId): orgId is string => Boolean(orgId));
}

export const excludeTestOrganizationVariables = {
  excludeTestOrgNamePattern: EXCLUDE_TEST_ORG_NAME_NILIKE,
};
